"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var efficient_frontier_port_chart_1 = require("./efficient-frontier-port.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var EfficientFrontierPortComponent = /** @class */ (function (_super) {
    __extends(EfficientFrontierPortComponent, _super);
    function EfficientFrontierPortComponent($scope, $timeout, terminologyService) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'EfficientFrontierPort') || this;
        _this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawChart();
        };
        var ctrl = _this;
        $scope.$on('command:EFFICIENT_FRONTIER_PORT', function (event, args) { return ctrl.initComponent(event, args); });
        // Get terminology directly from service
        _this.terminology = terminologyService.getCurrentTerminology();
        return _this;
    }
    EfficientFrontierPortComponent.prototype.getChartOptions = function (graph, options) {
        return efficient_frontier_port_chart_1.getChartOptions(graph, options);
    };
    // Required abstract method implementation
    EfficientFrontierPortComponent.prototype.makeChart = function (series) {
        // This method is required by BasicChartComponent but not used in this component
        // The chart is created in the drawChart method using makeChart helper function
    };
    // Override the exportCsv method to pass terminology
    EfficientFrontierPortComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        var ctrl = this;
        var filename = this.filename();
        ctrl.$scope.$broadcast('export:csv', { filename: filename, csvFormat: csvFormat, terminology: ctrl.terminology });
    };
    EfficientFrontierPortComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./efficient-frontier-port.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], EfficientFrontierPortComponent);
    return EfficientFrontierPortComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.EfficientFrontierPortComponent = EfficientFrontierPortComponent;
EfficientFrontierPortComponent.$inject = ['$scope', '$timeout', 'terminologyService'];
angular.module('smartorg.r6.acts.efficientFrontierPort', []).component('efficientFrontierPort', EfficientFrontierPortComponent);
module.exports = 'smartorg.r6.acts.efficientFrontierPort';
//# sourceMappingURL=efficient-frontier-port.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/efficient-frontier-port/efficient-frontier-port.component.js